import React from 'react';
import SEO from '../components/SEO';

const CookiePolicy: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Politique des Cookies',
    description: 'Politique des cookies de BetSprinto',
  };

  return (
    <>
      <SEO
        title="Politique des Cookies - BetSprinto"
        description="Découvrez comment BetSprinto utilise les cookies et comment gérer vos préférences."
        jsonLd={jsonLd}
      />

      <div className="min-h-screen pt-28 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Politique des <span className="text-gradient">Cookies</span>
          </h1>
          <p className="text-gray-400 mb-8">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

          <div className="glass rounded-2xl p-8 md:p-12 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Qu'est-ce qu'un Cookie ?</h2>
              <p className="text-gray-300 leading-relaxed">
                Un cookie est un petit fichier texte stocké sur votre appareil lorsque vous
                visitez un site web. Les cookies permettent au site de mémoriser vos actions et
                préférences pendant une certaine période.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Types de Cookies Utilisés</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Cookies Essentiels</h3>
                  <p className="text-gray-300 leading-relaxed">
                    Ces cookies sont nécessaires au fonctionnement du site. Ils incluent les
                    cookies de consentement, de vérification d'âge et de session. Ils ne peuvent pas
                    être désactivés.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Cookies Analytiques</h3>
                  <p className="text-gray-300 leading-relaxed">
                    Ces cookies nous aident à comprendre comment les visiteurs utilisent notre site
                    en collectant des informations anonymes. Ils nous permettent d'améliorer
                    l'expérience utilisateur.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Cookies de Préférences</h3>
                  <p className="text-gray-300 leading-relaxed">
                    Ces cookies mémorisent vos choix (langue, région) pour personnaliser votre
                    expérience lors de visites ultérieures.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Gestion des Cookies</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Vous pouvez gérer vos préférences de cookies de plusieurs façons :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Via la fenêtre de consentement qui apparaît lors de votre première visite</li>
                <li>En modifiant les paramètres de votre navigateur</li>
                <li>En supprimant les cookies déjà stockés</li>
              </ul>
              <p className="text-gray-300 leading-relaxed mt-4">
                Notez que la désactivation de certains cookies peut affecter le fonctionnement du
                site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Cookies Tiers</h2>
              <p className="text-gray-300 leading-relaxed">
                Certains cookies peuvent être placés par des services tiers (analytics, réseaux
                sociaux). Ces cookies sont soumis aux politiques de confidentialité respectives de
                ces tiers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Durée de Conservation</h2>
              <p className="text-gray-300 leading-relaxed">
                Les cookies de session sont supprimés lorsque vous fermez votre navigateur. Les
                cookies persistants restent sur votre appareil jusqu'à leur expiration ou jusqu'à ce
                que vous les supprimiez manuellement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Contact</h2>
              <p className="text-gray-300 leading-relaxed">
                Pour toute question concernant notre utilisation des cookies, contactez-nous à :{' '}
                <a href="mailto:contact@betsprinto.com" className="text-accent-primary hover:underline">
                  contact@betsprinto.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;

